/**
 * فرستادنِ بازخورد — قرینه‌ی apps/mobile/app/feedback.tsx.
 * عمداً به همون جدولِ خطاهای خودکار می‌رود (`client_errors`)، تا گزارشِ
 * کاربر کنارِ خطاهای همون لحظه دیده شود.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { reportError } from '@/core/lib/report';
import { sendDiag } from '@/core/lib/diagLog';
import { t, useLocale } from '@/core/lib/i18n';
import { Btn, Card, Checkbox, Help } from '@/ui/kit';

type Kind = 'bug' | 'idea' | 'other';
const OPTIONS: { value: Kind; labelKey: string }[] = [
  { value: 'bug', labelKey: 'feedbackBug' },
  { value: 'idea', labelKey: 'feedbackIdea' },
  { value: 'other', labelKey: 'feedbackOther' },
];

export function FeedbackPage() {
  useLocale();
  const nav = useNavigate();
  const [kind, setKind] = useState<Kind>('bug');
  const [text, setText] = useState('');
  /** قرینه‌ی همین تیک در apps/mobile/app/feedback.tsx — توضیحش آن‌جاست. */
  const [diag, setDiag] = useState(true);

  const send = useMutation({
    mutationFn: async () => {
      const token = kind === 'bug' && diag ? await sendDiag('feedback') : null;
      reportError(`feedback.${kind}`, new Error(text.trim()),
        token ? { diag: token } : undefined);
    },
    onSuccess: () => nav('/settings'),
  });

  return (
    <div className="feed">
      {/* «نسخه‌ی اپ خودکار ضمیمه می‌شود» پشتِ «؟» کنارِ عنوان. */}
      <h1 className="feed-title">{t('feedback')}<Help text={t('feedbackNote')} /></h1>

      <Card>
        <div className="chiprow">
          {OPTIONS.map((o) => (
            <button key={o.value} type="button" className={`chip${kind === o.value ? ' on' : ''}`}
              onClick={() => setKind(o.value)}>
              {t(o.labelKey)}
            </button>
          ))}
        </div>

        <textarea className="input textarea" placeholder={t('feedbackPlaceholder')}
          value={text} onChange={(e) => setText(e.target.value)} rows={6} />
        {text.trim() ? <p className="dim">{text.trim().length}</p> : null}

        {kind === 'bug' ? (
          <Checkbox label={t('feedbackDiag')} checked={diag} onChange={setDiag} />
        ) : null}

        <Btn label={send.isPending ? '…' : t('send')}
          disabled={!text.trim() || send.isPending} onClick={() => send.mutate()} />
      </Card>
    </div>
  );
}
